import { Component, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { IReservation } from 'app/shared/models/reservation.interfaces'
import { ResourceService } from 'app/shared/resources/resource.service'
import { ReservationService } from 'app/shared/reservation/reservation.service'
import { CookieService } from 'app/shared/cookie.service'
import { Title } from '@angular/platform-browser'

@Component({
    selector: 'sbw-booking',
    templateUrl: './booking.component.html',
    styleUrls: ['./booking.component.css']
})
export class BookingComponent implements OnInit {

    public reservation: IReservation

    public reservationCode: string
    public loaded = false
    public printReservationUrl: string
    public errors: string[] = []
    public status = Status
    public isAgent: boolean

    constructor(
        private route: ActivatedRoute,
        private resourceService: ResourceService,
        private reservationService: ReservationService,
        private cookieService: CookieService,
        private title: Title
    ) { }

    ngOnInit() {
        this.isAgent = localStorage.getItem('sbw_AgentGenericId') ? true : false;

        this.reservationCode = this.route.snapshot.params['reservationCode'];
        this.printReservationUrl = `/_mvc/booking/reservation/${this.reservationCode}/pdf`;
        this.reservationService.getReservation(this.reservationCode).subscribe(reservation => {

            this.cookieService.setCookie('sbRouteCode', reservation.routeCode)
            this.resourceService.loadResources(reservation.routeCode, reservation.locale, ['Common', 'Amendment', 'Menu', 'Meals', 'Currency', 'CabinAllocation', 'Passengers'].concat(this.isAgent ? ['Agent', 'MenuAgent'] : []))
            this.resourceService.get('TITLE_BOOKING_DETAILS', false).subscribe(s => s && this.title.setTitle(s.replace('%reservationId%', this.reservationCode)))

            if (this.isShortSea(reservation)) { reservation.isReadOnly = false } // TODO MUST REMOVE WHEN BACKEND IMPLEMENTS READONLY FLAG FOR SHORT SEA
            this.reservation = reservation
            if (reservation.isReadOnly) {
                this.resourceService.get('AMENDMENT_READ_ONLY').subscribe(s => s && this.errors.push(s))
            }
        })
    }

    get ReservationStatus(): Status {
        if (!this.reservation) { return Status.Unset }
        if (this.reservation.reservationStatus === 'Confirmed' && !this.reservation.isReadOnly) {
            return Status.Active
        }
        return Status.Inactive
    }

    public isShortSea(reservation: IReservation): boolean {
        const noAmendmentForTheseRoutes = ['DVDK', 'DKDV', 'DVCA', 'CADV']
        return noAmendmentForTheseRoutes.indexOf(reservation.routeCode) !== -1
    }
}

enum Status { Unset, Active, Inactive }
